import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TypeaheadModule as ComponentTypeaheadModule } from '@psu/components/typeahead';
import { CoreModule, FilterModule } from '@starfish-access/core';
import { StarfishCommonModule, TypeaheadModule } from '@starfish-access/shared';
import { EditRowModule } from '../edit-row/edit-row.module';
import { AuthFlowComponent } from './auth-flow/auth-flow.component';
import { ColorSelectorComponent } from './color-selector/color-selector.component';
import { DescriptionsComponent } from './descriptions/descriptions.component';
import { DynamicRoleComponent } from './dynamic-role.component';
import { DynamicRolesEffects } from './dynamic-role.effects';
import { DynamicRolesFacade } from './dynamic-role.facade.service';
import { dynamicRolesReducer } from './dynamic-role.reducer';
import { routes } from './dynamic-role.routing';
import { EditRoleGroupComponent } from './edit-role-group/edit-role-group.component';
import { EditRoleNameComponent } from './edit-role-name/edit-role-name.component';
import { EditRoleComponent } from './edit-role/edit-role.component';
import { GroupPriorityComponent } from './group-priority/group-priority.component';
import { IconPreviewComponent } from './icon-preview/icon-preview.component';
import { IconSelectorComponent } from './icon-selector/icon-selector.component';
import { NewRoleGroupComponent } from './new-role-group/new-role-group.component';
import { OrgsComponent } from './orgs/orgs.component';
import { OrgsFacade } from './orgs/orgs.facade';
import { RoleDetailsFormComponent } from './role-details-form/role-details-form.component';
import { RoleDetailsFormFacade } from './role-details-form/role-details-form.facade';
import { SelectRoleGroupComponent } from './select-role-group/select-role-group.component';
import { ServiceSelectorComponent } from './service-selector/service-selector.component';
import { ServiceToOrgPipe } from './service-selector/service-to-org.pipe';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    FlexLayoutModule,
    TypeaheadModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    MatProgressBarModule,
    MatSelectModule,
    EditRowModule,
    MatChipsModule,
    DragDropModule,
    MatTabsModule,
    MatTooltipModule,
    FilterModule,
    MatExpansionModule,
    StarfishCommonModule,
    ComponentTypeaheadModule,
    MatSlideToggleModule,
    RouterModule.forChild(routes),
    StoreModule.forFeature('dynamicRoles', dynamicRolesReducer),
    EffectsModule.forFeature([DynamicRolesEffects]),
  ],
  declarations: [
    DynamicRoleComponent,
    OrgsComponent,
    NewRoleGroupComponent,
    ColorSelectorComponent,
    IconSelectorComponent,
    GroupPriorityComponent,
    IconPreviewComponent,
    EditRoleComponent,
    EditRoleNameComponent,
    SelectRoleGroupComponent,
    RoleDetailsFormComponent,
    EditRoleGroupComponent,
    AuthFlowComponent,
    ServiceSelectorComponent,
    ServiceToOrgPipe,
    DescriptionsComponent,
  ],
  exports: [DynamicRoleComponent, ServiceSelectorComponent, ServiceToOrgPipe],
  providers: [DynamicRolesFacade, OrgsFacade, RoleDetailsFormFacade],
})
export class DynamicRoleModule {}
